import NodeRSA from 'node-rsa';
import { publicKey } from "./public-mini.js";
/* 注:采用标准模式:公钥加密 */

/**
 * rsa加密
 * @param {*} data 需要加密的内容,String格式
 * @returns
 */
export function rsaEncrypt(data) {
  return new Promise((resolve, reject) => {
    /* 标准模式 */
    var key = new NodeRSA(publicKey);
    key.setOptions({ encryptionScheme: "pkcs1_oaep" });
    let cipherText = key.encrypt(data, "base64");
    resolve(cipherText);
  }).catch((err) => {
    console.log(err);
    return "权限不足,请联系管理员客服人员";
  });
}
